(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroGallery {
    constructor(element) {
      this.hero = element;
      this.slides = Array.from(element.querySelectorAll('.hero-slide'));
      this.dots = Array.from(element.querySelectorAll('.hero-dot'));
      this.prevBtn = element.querySelector('[data-hero-prev]');
      this.nextBtn = element.querySelector('[data-hero-next]');
      this.totalSlides = this.slides.length;

      if (this.totalSlides <= 1) {
        // Single slide: ensure video plays if present
        this.playSlideMedia(0);
        return;
      }

      this.currentIndex = 0;
      this.autoplayEnabled = element.dataset.autoplay !== 'false';
      this.speed = parseInt(element.dataset.speed, 10) || 6000;
      this.timer = null;
      this.isPaused = false;

      this.init();
    }

    init() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.prev();
          this.restartAutoplay();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.next();
          this.restartAutoplay();
        });
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goTo(index);
          this.restartAutoplay();
        });
      });

      // Pause on hover
      this.hero.addEventListener('mouseenter', () => {
        this.isPaused = true;
        this.clearTimer();
      });

      this.hero.addEventListener('mouseleave', () => {
        this.isPaused = false;
        this.startAutoplay();
      });

      // Touch / Swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      this.hero.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.hero.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
          this.restartAutoplay();
        }
      }, { passive: true });

      this.playSlideMedia(this.currentIndex);
      this.startAutoplay();
    }

    goTo(index) {
      if (index === this.currentIndex) return;

      const outgoingIndex = this.currentIndex;
      this.currentIndex = (index + this.totalSlides) % this.totalSlides;

      // Update slide active classes
      this.slides.forEach((slide, idx) => {
        const isActive = idx === this.currentIndex;
        slide.classList.toggle('is-active', isActive);
      });

      // Update dots
      this.dots.forEach((dot, idx) => {
        const isActive = idx === this.currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Handle media playback
      this.pauseSlideMedia(outgoingIndex);
      this.playSlideMedia(this.currentIndex);
    }

    next() {
      this.goTo(this.currentIndex + 1);
    }

    prev() {
      this.goTo(this.currentIndex - 1);
    }

    playSlideMedia(index) {
      const slide = this.slides[index];
      if (!slide) return;
      const video = slide.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play().catch(() => {});
      }
    }

    pauseSlideMedia(index) {
      const slide = this.slides[index];
      if (!slide) return;
      const video = slide.querySelector('video');
      if (video) {
        video.pause();
      }
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.isPaused || this.totalSlides <= 1) return;
      this.clearTimer();
      this.timer = setTimeout(() => {
        this.next();
        this.startAutoplay();
      }, this.speed);
    }

    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.clearTimer();
      this.startAutoplay();
    }
  }

  function initHeroGalleries() {
    document.querySelectorAll('[data-hero-gallery]').forEach((el) => {
      if (!el._heroGallery) {
        el._heroGallery = new HeroGallery(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroGalleries);
  } else {
    initHeroGalleries();
  }

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:block:select', (event) => {
    const hero = event.target.closest('[data-hero-gallery]');
    if (hero && hero._heroGallery) {
      const slideIndex = parseInt(event.target.getAttribute('data-slide-index'), 10);
      if (!isNaN(slideIndex)) {
        hero._heroGallery.goTo(slideIndex);
        hero._heroGallery.isPaused = true;
        hero._heroGallery.clearTimer();
      }
    }
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const hero = event.target.closest('[data-hero-gallery]');
    if (hero && hero._heroGallery) {
      hero._heroGallery.isPaused = false;
      hero._heroGallery.startAutoplay();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
